// extracted by mini-css-extract-plugin
export default {"container":"SummaryAsset_container__bHvm2"};